import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton";

// Pages
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Article from "./pages/Article";
import Process from "./pages/Process";
import Careers from "./pages/Careers";
import Pizza from "./pages/Pizza";
import ItemPage from "./pages/menu/ItemPage";
import PizzaAcademyPage from "./pages/PizzaAcademyPage";
import ReservationsPage from "./pages/ReservationsPage";
import CorporateEventsPage from "./pages/CorporateEventsPage";
import PlacementPage from "./pages/partners";
import CanonicalCleanup from "./components/CanonicalCleanup";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="bg-white text-gray-900 font-sans">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/menu/:slug" element={<ItemPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Article />} />
          <Route path="/reservations" element={<ReservationsPage />} />
          <Route path="/pizza" element={<Pizza />} />
          <Route path="/process" element={<Process />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/join" element={<Careers />} />
          <Route path="/partners" element={<PlacementPage />} />
          <Route path="/academy" element={<PizzaAcademyPage />} />
          <Route path="/corporate" element={<CorporateEventsPage />} />
          
        </Routes>
        <ScrollToTopButton />
          <CanonicalCleanup />

      </div>
    </Router>
  );
}

export default App;